module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4 class="icon-header bluetooth">'+
((__t=( alias ))==null?'':__t)+
'</h4><div class="content"><dl> ';
 if ( serialNumber ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "BluetoothSettings", "Serial number:" ) ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( serialNumber ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( transientHardwareVersion ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "BluetoothSettings", "Hardware number:" ) ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( transientHardwareVersion ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( transientBuildNumber ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "BluetoothSettings", "Build number:" ) ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( transientBuildNumber ))==null?'':__t)+
'</dd> ';
 } 
__p+=' ';
 if ( transientApiVersion ) { 
__p+=' <dt>'+
((__t=( i18n.tc( "BluetoothSettings", "API-version:" ) ))==null?'':__t)+
'</dt><dd class="success">'+
((__t=( transientApiVersion ))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl></div><fieldset> ';
 if ( transientUpgradeAvailable && ! transientOffline ) { 
__p+=' <button data-click="bluetooth-upgrade">'+
((__t=( i18n.tc( "BluetoothSettings", "Update firmware" ) ))==null?'':__t)+
'</button> ';
 } 
__p+=' <button data-click="bluetooth-delete">'+
((__t=( i18n.tc( "BluetoothSettings", "Delete" ) ))==null?'':__t)+
'</button></fieldset><fieldset class="button-wrap"><button data-click="bluetooth-cancel">'+
((__t=( i18n.tc( "BluetoothSettings", "Cancel" ) ))==null?'':__t)+
'</button> ';
 if ( ! transientOffline ) { 
__p+=' <button class="primary" data-click="bluetooth-open">'+
((__t=( i18n.tc( "BluetoothSettings", "Open device" ) ))==null?'':__t)+
'</button> ';
 } 
__p+=' </fieldset>';
}
return __p;
};
